<!--<img src="assets/icons/close.svg" class="close" (click)="close()">-->
<div class="modal">
    <div class="title font-h2">{{data.card.title}}</div>
    <div class="content">
        <img [src]="data.card.image">
        <div class="text font-body2">{{data.card.fullText}}</div>
    </div>
</div>